import {
    SET_ORDER_METHOD,
    SET_CHECKOUT_ORDER_DATA,
    HIDE_CART_CATEGORY_MIX_ALERT,
    SHOW_CART_CATEGORY_MIX_ALERT,
    HIDE_CARD_PROCESSING_TIMEOUT_ALERT,
    SHOW_CARD_PROCESSING_TIMEOUT_ALERT,
    SET_CHECKOUT_DELIVERY_DISTANCE,
    RESET_PIN_CODE_ERROR,
    RESET_PIN_CODE,
    SET_PIN_CODE_UNCONFIRMED,
    SET_PIN_CODE_CONFIRMED,
    CHECKOUT_PROCESS_UPDATED_DATA,
    HIDE_MINIMUM_CHECKOUT_ALERT,
    SHOW_MINIMUM_CHECKOUT_ALERT,
    SET_ORDER_PROMO_RESET,
    SET_ORDER_PROMO_CODE,
    SET_ORDER_PROMO,
    CHECKOUT_PROCESS_DATA,
    SET_PAYMENT_METHOD,
    SET_ORDER_SCHEDULE_IS_TIME_SLOT,
    SET_ORDER_SCHEDULE_TIME,
    SET_ORDER_SCHEDULE,
    SET_ORDER_METHOD_TYPE,
    SET_ORDER_TIP_FIX,
    SET_ORDER_TIP_RATE,
    SET_ORDER_TIP_TYPE,
    SET_ORDER_METHOD_VALIDATED,
    CHECKOUT_ERROR,
    SET_CHECKOUT_DATA,
    SET_ENABLE_UTENSILS_NAPKINS,
    SET_CHECKOUT_EXTERNAL_DELIVERY_DATA
} from '../actions/checkout.actions';
import { orderMethods, orderMethodTypes, paymentMethods, tipTypes } from '../../constants/checkout';

const initialState = {
    orderMethod: orderMethods.pickup,
    orderMethodType: orderMethodTypes.asap,
    schedulePeriod: null,
    scheduleTime: null,
    isTimeSlot: false,
    enableUtensilsNapkins: false,
    paymentMethod: paymentMethods.card,
    checkoutData: null,
    processData: null,
    processUpdatedData: null,
    tip: {
        type: tipTypes.rate,
        rate: 0.00,
        fix: 0.00
    },
    promoCode: null,
    promo: {
        rate: 0.00,
        value: 0.00
    },
    deliveryDriverTip: 0.00,
    externalDeliveryDriverTip: 0.00,
    externalDeliveryFee: 0.00,
    externalDeliveryTax: 0.00,
    deliveryValidated: false,
    externalDeliveryValidated: false,
    pickupValidated: false,
    isShowMinimumAlert: false,
    isShowCartCategoryMixAlert: false,
    categoryMixAlert: null,
    isConfirmedPinCode: false,
    isCardProcessingTimeoutAlert: false,
    pinCodeToken: null,
    pinCodeError: null,
    deliveryDistance: 0,
    error: null,
    orderData: null
};

const CheckoutReducer = function (state = initialState, action) {
    switch (action.type) {
        case SET_ORDER_METHOD:
            return {
                ...state,
                orderMethod: action.method
            };
        case SET_CHECKOUT_DATA:
            return {
                ...state,
                checkoutData: action.payload
            };
        case CHECKOUT_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case SET_ORDER_METHOD_VALIDATED:
            return {
                ...state,
                ...action.valid
            };
        case SET_ORDER_TIP_TYPE:
            return {
                ...state,
                tip: {
                    ...state.tip,
                    type: action.tipType
                }
            };
        case SET_ORDER_TIP_RATE:
            return {
                ...state,
                tip: {
                    ...state.tip,
                    fix: 0.00,
                    rate: action.tipRate
                }
            };
        case SET_ORDER_TIP_FIX:
            return {
                ...state,
                tip: {
                    ...state.tip,
                    fix: action.tipFix,
                    rate: 0.00
                }
            };
        case SET_ORDER_METHOD_TYPE:
            return {
                ...state,
                orderMethodType: action.method
            };
        case SET_ORDER_SCHEDULE:
            return {
                ...state,
                schedulePeriod: action.schedule
            };
        case SET_ORDER_SCHEDULE_TIME:
            return {
                ...state,
                scheduleTime: action.time
            };
        case SET_ORDER_SCHEDULE_IS_TIME_SLOT:
            return {
                ...state,
                isTimeSlot: !!action.payload
            };
        case SET_PAYMENT_METHOD:
            if (paymentMethods.cash === action.method) {
                return {
                    ...state,
                    tip: {
                        ...initialState.tip
                    },
                    paymentMethod: action.method
                };
            }
            return {
                ...state,
                paymentMethod: action.method
            };
        case SET_ENABLE_UTENSILS_NAPKINS:
            return {
                ...state,
                enableUtensilsNapkins: !state.enableUtensilsNapkins,
            };
        case CHECKOUT_PROCESS_DATA:
            return {
                ...state,
                processData: {
                    ...state.processData,
                    clientSecret: action.clientSecret,
                    success_url: action.success_url,
                    cancel_url: action.cancel_url,
                    token: action.token || null,
                }
            };
        case SET_ORDER_PROMO:
            return {
                ...state,
                promo: {
                    ...state.promo,
                    ...action.promo
                }
            };
        case SET_ORDER_PROMO_CODE:
            return {
                ...state,
                promoCode: action.code
            };
        case SET_ORDER_PROMO_RESET:
            return {
                ...state,
                promo: initialState.promo
            };
        case SHOW_MINIMUM_CHECKOUT_ALERT:
            return {
                ...state,
                isShowMinimumAlert: true
            };
        case HIDE_MINIMUM_CHECKOUT_ALERT:
            return {
                ...state,
                isShowMinimumAlert: false
            };
        case CHECKOUT_PROCESS_UPDATED_DATA:
            return {
                ...state,
                processUpdatedData: action.payload
            };
        case SET_PIN_CODE_CONFIRMED:
            return {
                ...state,
                isConfirmedPinCode: true,
                pinCodeToken: action.token,
                pinCodeError: null
            };
        case SET_PIN_CODE_UNCONFIRMED:
            return {
                ...state,
                isConfirmedPinCode: false,
                pinCodeToken: null,
                pinCodeError: action.message
            };
        case RESET_PIN_CODE:
            return {
                ...state,
                isConfirmedPinCode: false,
                pinCodeToken: null,
                pinCodeError: null
            };
        case RESET_PIN_CODE_ERROR:
            return {
                ...state,
                pinCodeError: null
            };
        case SET_CHECKOUT_DELIVERY_DISTANCE:
            return {
                ...state,
                deliveryDistance: action.payload,
            };
        case SHOW_CARD_PROCESSING_TIMEOUT_ALERT:
            return {
                ...state,
                isCardProcessingTimeoutAlert: true
            };
        case HIDE_CARD_PROCESSING_TIMEOUT_ALERT:
            return {
                ...state,
                isCardProcessingTimeoutAlert: false
            };
        case SHOW_CART_CATEGORY_MIX_ALERT:
            return {
                ...state,
                isShowCartCategoryMixAlert: true,
                categoryMixAlert: action.payload
            };
        case HIDE_CART_CATEGORY_MIX_ALERT:
            return {
                ...state,
                isShowCartCategoryMixAlert: false,
                categoryMixAlert: null
            };
        case SET_CHECKOUT_ORDER_DATA:
            return {
                ...state,
                orderData: {
                    ...action.payload
                }
            };
        case SET_CHECKOUT_EXTERNAL_DELIVERY_DATA:
            return {
                ...state,
                externalDeliveryDriverTip: action.payload.driver_tip,
                externalDeliveryFee: action.payload.fee,
                externalDeliveryTax: action.payload.tax,
            };
        default:
            return state;
    }
};

export default CheckoutReducer;